<template>
  <div class="customer-detail-view">
    <!-- En-tête -->
    <div class="page-header">
      <button @click="$router.push({ name: 'customers' })" class="back-btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Retour
      </button>
      <div class="header-actions">
        <button @click="sendSMS" class="action-btn secondary">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
          SMS
        </button>
        <button @click="sendEmail" class="action-btn secondary">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          Email
        </button>
        <button @click="editCustomer" class="action-btn primary">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
          </svg>
          Modifier
        </button>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="loading" class="loading-container">
      <div class="spinner"></div>
      <p>Chargement...</p>
    </div>

    <!-- Message d'erreur -->
    <div v-else-if="!loading && !customer.id" class="not-found-container">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="1.5">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <h2>Client introuvable</h2>
      <p>Le client que vous recherchez n'existe pas.</p>
      <button @click="$router.push({ name: 'customers' })" class="action-btn primary">
        Retour aux clients
      </button>
    </div>

    <!-- Contenu -->
    <div v-else class="customer-content">
      <!-- Section haute: Infos client + Stats sur la même ligne -->
      <div class="top-section">
        <!-- Carte profil -->
        <div class="profile-card">
          <div class="profile-header">
            <div class="avatar">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <div class="profile-info">
              <h1 class="customer-name">{{ customer.name }}</h1>
              <p class="member-since">Membre depuis {{ formatDate(customer.created_at) }}</p>
            </div>
          </div>

          <div class="contact-section">
            <div v-if="customer.phone" class="contact-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path
                  d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                </path>
              </svg>
              <span>{{ customer.phone }}</span>
            </div>
            <div v-if="customer.email" class="contact-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22 6 12 13 2 6"></polyline>
              </svg>
              <span>{{ customer.email }}</span>
            </div>
            <div v-if="customer.full_address" class="contact-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span>{{ customer.full_address }}</span>
            </div>
          </div>

          <!-- Status Switch -->
          <div class="status-section">
            <div class="status-toggle">
              <span class="status-label">Statut du client</span>
              <div class="switch-container">
                <span class="switch-label" :class="{ inactive: customer.status }">Inactif</span>
                <button class="switch-btn" :class="{ active: customer.status }" @click="openStatusConfirmModal"
                  :disabled="isTogglingStatus">
                  <span class="switch-slider"></span>
                </button>
                <span class="switch-label" :class="{ inactive: !customer.status }">Actif</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Stats -->
        <div class="stats-grid">
          <!-- Portefeuille -->
          <div class="stat-card wallet-card">
            <div class="stat-icon purple">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path>
                <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path>
                <path d="M18 12a2 2 0 0 0 0 4h4v-4h-4z"></path>
              </svg>
            </div>
            <div class="stat-details">
              <span v-if="walletLoading" class="stat-value">...</span>
              <span v-else class="stat-value">{{ formatCurrency(wallet?.balance || 0) }}</span>
              <span class="stat-label">Solde portefeuille</span>
            </div>
            <button
              class="credit-wallet-btn"
              @click="openCreditWalletModal"
              title="Créditer le portefeuille"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
            </button>
          </div>

          <!-- Ventes -->
          <div class="stat-card">
            <div class="stat-icon blue">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
            </div>
            <div class="stat-details">
              <span class="stat-value">{{ customer.sales_count || 0 }}</span>
              <span class="stat-label">Ventes</span>
            </div>
          </div>

          <!-- Total payé -->
          <div class="stat-card">
            <div class="stat-icon green">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="1" x2="12" y2="23"></line>
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
              </svg>
            </div>
            <div class="stat-details">
              <span class="stat-value">{{ formatCurrency(customer.total_spent || 0) }}</span>
              <span class="stat-label">Total payé</span>
            </div>
          </div>

          <!-- Impayées -->
          <div class="stat-card" :class="{ warning: customer.total_unpaid > 0 }">
            <div class="stat-icon" :class="customer.total_unpaid > 0 ? 'orange' : 'gray'">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
            </div>
            <div class="stat-details">
              <span class="stat-value">{{ formatCurrency(customer.total_unpaid || 0) }}</span>
              <span class="stat-label">{{ customer.unpaid_sales_count || 0 }} impayée(s)</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Section basse: Tabs -->
      <div class="bottom-section">
        <!-- Tabs navigation -->
        <div class="tabs-navigation">
          <button
            :class="['tab-btn', { active: activeTab === 'sales' }]"
            @click="activeTab = 'sales'"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
            Ventes
          </button>
          <button
            :class="['tab-btn', { active: activeTab === 'invoices' }]"
            @click="activeTab = 'invoices'"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
            Facturations
          </button>
          <button
            :class="['tab-btn', { active: activeTab === 'transactions' }]"
            @click="activeTab = 'transactions'"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path>
              <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path>
              <path d="M18 12a2 2 0 0 0 0 4h4v-4h-4z"></path>
            </svg>
            Transactions
          </button>
        </div>
        <br>
        <!-- Tab content -->
        <div class="tabs-content">
          <CustomerSalesHistory
            v-if="activeTab === 'sales'"
            :customer-id="customer.id"
            :wallet="wallet"
            :customer="customer"
            @refresh="loadCustomerDetails"
          />
          <CustomerSaleInvoice
            v-if="activeTab === 'invoices'"
            :customer-id="customer.id"
          />
          <CustomerWalletTransactions
            v-if="activeTab === 'transactions' && wallet?.id"
            :wallet-id="wallet.id"
          />
        </div>
      </div>
    </div>

    <!-- Modal de crédit du portefeuille -->
    <CreditWalletModal
      :show="showCreditWalletModal"
      :customer-id="customer.id"
      :customer-name="customer.name"
      :current-balance="wallet?.balance || 0"
      @close="closeCreditWalletModal"
      @credit-added="onCreditAdded"
    />

    <!-- Modal de confirmation changement de statut -->
    <Teleport to="body">
      <div v-if="showStatusConfirmModal" class="confirm-modal-overlay" @click.self="closeStatusConfirmModal">
        <div class="confirm-modal">
          <div class="confirm-modal-icon" :class="customer.status ? 'warning' : 'success'">
            <svg v-if="customer.status" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <h3 class="confirm-modal-title">
            {{ customer.status ? 'Désactiver le client ?' : 'Activer le client ?' }}
          </h3>
          <p class="confirm-modal-message">
            {{ customer.status
              ? `Êtes-vous sûr de vouloir désactiver "${customer.name}" ? Ce client ne pourra plus être sélectionné pour
            de nouvelles ventes.`
              : `Êtes-vous sûr de vouloir activer "${customer.name}" ? Ce client sera de nouveau disponible pour les
            ventes.`
            }}
          </p>
          <div class="confirm-modal-actions">
            <button @click="closeStatusConfirmModal" class="confirm-btn cancel" :disabled="isTogglingStatus">
              Annuler
            </button>
            <button @click="confirmToggleStatus" class="confirm-btn" :class="customer.status ? 'danger' : 'success'"
              :disabled="isTogglingStatus">
              <span v-if="isTogglingStatus" class="spinner-small"></span>
              <span v-else>{{ customer.status ? 'Désactiver' : 'Activer' }}</span>
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import customerService from '@/services/customerService';
import CustomerSalesHistory from '@/components/customers/CustomerSalesHistory.vue';
import CustomerSaleInvoice from '@/components/customers/CustomerSaleInvoice.vue';
import CreditWalletModal from '@/components/customers/CreditWalletModal.vue';
import CustomerWalletTransactions from '@/components/customers/CustomerWalletTransactions.vue';

export default defineComponent({
  name: 'CustomerDetail',
  components: {
    CustomerSalesHistory,
    CustomerSaleInvoice,
    CreditWalletModal,
    CustomerWalletTransactions
  },
  setup() {
    const route = useRoute();
    const router = useRouter();

    const customer = ref({});
    const loading = ref(true);
    const activeTab = ref('sales');

    // Wallet
    const wallet = ref(null);
    const walletLoading = ref(false);
    const showCreditWalletModal = ref(false);

    // Status toggle
    const showStatusConfirmModal = ref(false);
    const isTogglingStatus = ref(false);

    const loadCustomerDetails = async () => {
      const customerId = route.params.id;
      if (!customerId) {
        router.push({ name: 'customers' });
        return;
      }

      try {
        loading.value = true;
        const response = await customerService.getCustomer(customerId);
        customer.value = response.data.customer || response.data;
        // Charger le portefeuille après avoir chargé le client
        loadWallet();
      } catch (error) {
        console.error('Erreur:', error);
        customer.value = {};
      } finally {
        loading.value = false;
      }
    };

    const loadWallet = async () => {
      const customerId = route.params.id;
      if (!customerId) return;

      try {
        walletLoading.value = true;
        const response = await customerService.getCustomerWallet(customerId);
        console.log('response', response.data);
        wallet.value = response.data.data;
      } catch (error) {
        console.error('Erreur lors du chargement du portefeuille:', error);
        wallet.value = null;
      } finally {
        walletLoading.value = false;
      }
    };

    const openCreditWalletModal = () => {
      showCreditWalletModal.value = true;
    };

    const closeCreditWalletModal = () => {
      showCreditWalletModal.value = false;
    };

    const onCreditAdded = () => {
      loadWallet();
      closeCreditWalletModal();
    };

    const editCustomer = () => {
      router.push({ name: 'customer-edit', params: { id: customer.value.id } });
    };

    const sendSMS = () => {
      console.log('TODO: Envoyer SMS au client', customer.value.id);
    };

    const sendEmail = () => {
      console.log('TODO: Envoyer Email au client', customer.value.id);
    };

    const formatCurrency = (amount) => {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'XOF',
        minimumFractionDigits: 0
      }).format(amount || 0);
    };

    const formatDate = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    };

    // Méthodes pour le toggle de statut
    const openStatusConfirmModal = () => {
      showStatusConfirmModal.value = true;
    };

    const closeStatusConfirmModal = () => {
      showStatusConfirmModal.value = false;
    };

    const confirmToggleStatus = async () => {
      if (isTogglingStatus.value) return;

      isTogglingStatus.value = true;
      try {
        if (customer.value.status) {
          await customerService.deactivateCustomer(customer.value.id);
        } else {
          await customerService.activateCustomer(customer.value.id);
        }

        customer.value.status = !customer.value.status;
        closeStatusConfirmModal();
      } catch (error) {
        console.error('Erreur lors du changement de statut:', error);
      } finally {
        isTogglingStatus.value = false;
      }
    };

    onMounted(() => {
      loadCustomerDetails();
    });

    return {
      customer,
      loading,
      activeTab,
      wallet,
      walletLoading,
      showCreditWalletModal,
      showStatusConfirmModal,
      isTogglingStatus,
      loadCustomerDetails,
      loadWallet,
      openCreditWalletModal,
      closeCreditWalletModal,
      onCreditAdded,
      openStatusConfirmModal,
      closeStatusConfirmModal,
      confirmToggleStatus,
      editCustomer,
      sendSMS,
      sendEmail,
      formatCurrency,
      formatDate
    };
  }
});
</script>

<style scoped>
.customer-detail-view {
  padding: 0;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #6b7280;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.back-btn:hover {
  background: #f9fafb;
}

.header-actions {
  display: flex;
  gap: 0.75rem;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.action-btn.primary {
  background: #0A5C6B;
  color: white;
}

.action-btn.primary:hover {
  background: #094854;
}

.action-btn.secondary {
  background: white;
  color: #6b7280;
  border: 1px solid #e5e7eb;
}

.action-btn.secondary:hover {
  background: #f9fafb;
}

.loading-container,
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background: white;
  border-radius: 12px;
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #0A5C6B;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

.spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  display: inline-block;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.customer-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* Section haute: infos + stats */
.top-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.profile-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  border-bottom: 1px solid #f3f4f6;
}

.avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  flex-shrink: 0;
}

.profile-info {
  flex: 1;
}

.customer-name {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 0.25rem 0;
}

.member-since {
  font-size: 0.8rem;
  color: #6b7280;
  margin: 0;
}

.contact-section {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.85rem;
  color: #6b7280;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.stat-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 1.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.stat-card.warning {
  background: #fffbeb;
  border: 1px solid #fcd34d;
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon.blue {
  background: #dbeafe;
  color: #1e40af;
}

.stat-icon.green {
  background: #d1fae5;
  color: #065f46;
}

.stat-icon.orange {
  background: #fed7aa;
  color: #c2410c;
}

.stat-icon.gray {
  background: #f3f4f6;
  color: #6b7280;
}

.stat-icon.purple {
  background: #ede9fe;
  color: #7c3aed;
}

.wallet-card {
  position: relative;
  background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);
  border: 1px solid #ddd6fe;
}

.credit-wallet-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #7c3aed;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(124, 58, 237, 0.3);
}

.credit-wallet-btn:hover {
  background: #6d28d9;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(124, 58, 237, 0.4);
}

.stat-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.stat-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
}

.stat-label {
  font-size: 0.75rem;
  color: #6b7280;
}

/* Section basse: Tabs */
.bottom-section {
  display: flex;
  flex-direction: column;
}

.tabs-navigation {
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.tab-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #6b7280;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.tab-btn:hover {
  background: #f3f4f6;
  color: #374151;
}

.tab-btn.active {
  background: #0A5C6B;
  color: white;
}

.tabs-content {
  margin-top: -1px;
}

/* Status Section */
.status-section {
  padding: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.status-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.status-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
}

.switch-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.switch-label {
  font-size: 0.8rem;
  font-weight: 500;
  color: #374151;
  transition: color 0.2s;
}

.switch-label.inactive {
  color: #9ca3af;
}

.switch-btn {
  position: relative;
  width: 48px;
  height: 26px;
  background: #e5e7eb;
  border: none;
  border-radius: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
}

.switch-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.switch-btn.active {
  background: linear-gradient(135deg, #0A5C6B 0%, #0d7a8c 100%);
}

.switch-slider {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.switch-btn.active .switch-slider {
  transform: translateX(22px);
}

/* Confirmation Modal */
.confirm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.confirm-modal {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 400px;
  padding: 32px;
  text-align: center;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: modalSlideIn 0.3s ease;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.confirm-modal-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.confirm-modal-icon.warning {
  background: #fef3c7;
  color: #f59e0b;
}

.confirm-modal-icon.success {
  background: #d1fae5;
  color: #059669;
}

.confirm-modal-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 12px;
}

.confirm-modal-message {
  font-size: 0.95rem;
  color: #6b7280;
  line-height: 1.5;
  margin: 0 0 24px;
}

.confirm-modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.confirm-btn {
  padding: 10px 24px;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 100px;
}

.confirm-btn.cancel {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  color: #4b5563;
}

.confirm-btn.cancel:hover:not(:disabled) {
  background: #e5e7eb;
}

.confirm-btn.danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border: none;
  color: white;
}

.confirm-btn.danger:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.confirm-btn.success {
  background: linear-gradient(135deg, #0A5C6B 0%, #0d7a8c 100%);
  border: none;
  color: white;
}

.confirm-btn.success:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(10, 92, 107, 0.3);
}

.confirm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

@media (max-width: 1024px) {
  .top-section {
    grid-template-columns: 1fr;
  }

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    gap: 1rem;
  }

  .header-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .tabs-navigation {
    flex-wrap: wrap;
  }
}

@media (max-width: 480px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
}
</style>
